import React, { useRef } from 'react'
import Card from './Card'
import { FaAngleRight, FaAngleLeft } from "react-icons/fa6";

const HorizontalScollCard = ({data = [], heading, trending, media_type}) => {
    const contaierRef = useRef()

    const handleNext = ()=>{
        contaierRef.current.scrollLeft += 300
    }
    const handlePrevious = ()=>{
        contaierRef.current.scrollLeft -= 300
    }
  return (
    <div className='container mx-auto px-3 my-10'>
          <h2 className='text-xl lg:text-2xl font-bold mb-5 text-very-light-gray capitalize font-space-grotesk'>{heading}</h2>

          <div className=' relative'>
                <div  ref={contaierRef} className='grid grid-cols-[repeat(auto-fit,230px)] grid-flow-col gap-6 overflow-hidden overflow-x-scroll relative z-10 scroll-smooth transition-all scrolbar-none'>
                    {
                        data.map((data,index)=>{
                        return (
                            <Card key={data.id+"heading"+index} data={data} index={index+1} trending={trending} media_type={media_type}/>
                        )
                        })
                    }
                </div>

                <div className='absolute top-0 hidden lg:flex justify-between w-full h-full items-center pointer-events-none'>
                    <button onClick={handlePrevious} className='bg-almost-black border border-border-color p-2 text-very-light-gray rounded-full -ml-2 z-10 hover:bg-dark-gray-4 hover:border-dark-gray-6 transition-all pointer-events-auto'>
                        <FaAngleLeft/>
                    </button>
                    <button onClick={handleNext} className='bg-almost-black border border-border-color p-2 text-very-light-gray rounded-full -mr-2 z-10 hover:bg-dark-gray-4 hover:border-dark-gray-6 transition-all pointer-events-auto'>
                        <FaAngleRight/>
                    </button>
                </div>
          </div>
          
        </div>
  )
}

export default HorizontalScollCard
